import {
  compose,
  mapObjIndexed,
  values,
  omit,
  path,
  propEq,
  filter,
  pluck,
} from 'ramda';
import { theme } from 'config';

const { violet, seafoamGreen, coral, softViolet, deepPurple } = theme;

type Count = [{ count: number }];

type TransactionEventRatio = {
  CLEARED: Count;
  AUTHORIZED: Count;
  RETURNED: Count;
};

const CARD_EVENT_LEGEND = [
  { type: ['AUTHORIZED'], title: 'Authorized', color: violet },
  { type: ['CLEARED'], title: 'Cleared', color: coral },
  { type: ['RETURNED'], title: 'Returned', color: seafoamGreen },
];

const RECEIVED_CARD_EVENTS_LEGEND = [
  { type: ['VISA', 'AUTHORIZED'], title: 'Visa Authorized', color: '#043381' },
  { type: ['VISA', 'CLEARED'], title: 'Visa Cleared', color: '#009BF6' },
  { type: ['VISA', 'RETURNED'], title: 'Visa Returned', color: '#00FFF5' },
  {
    type: ['MASTERCARD', 'AUTHORIZED'],
    title: 'MC Authorized',
    color: '#D0021B',
  },
  { type: ['MASTERCARD', 'CLEARED'], title: 'MC Cleared', color: '#A51F30' },
  { type: ['MASTERCARD', 'RETURNED'], title: 'MC Returned', color: '#FF0000' },
  { type: ['AMEX', 'AUTHORIZED'], title: 'Amex Authorized', color: '#8F3DE6' },
  { type: ['AMEX', 'CLEARED'], title: 'Amex Cleared', color: '#440C7F' },
  { type: ['AMEX', 'RETURNED'], title: 'Amex Returned', color: '#FF2AE3' },
];

const RATIO_CHART_LEGEND = [
  { title: 'Authorized', type: 'AUTHORIZED', color: deepPurple },
  { title: 'Cleared', type: 'CLEARED', color: violet },
  { title: 'Returned', type: 'RETURNED', color: softViolet },
];

const ratioChartMapping = (counts: Count, key: string) => {
  const [angle] = pluck('count' as any, counts);
  return {
    angle,
    label: key,
    color: path([0, 'color'], filter(propEq('type', key), RATIO_CHART_LEGEND)),
  };
};

const ratioChartTransformer = compose(
  values,
  mapObjIndexed(ratioChartMapping),
  omit(['__typename']),
) as any;

export {
  ratioChartTransformer,
  CARD_EVENT_LEGEND,
  RECEIVED_CARD_EVENTS_LEGEND,
  RATIO_CHART_LEGEND,
  TransactionEventRatio,
};
